import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { multilineEllipsis } from "./base.styles";
import { FlexColumn, FlexRow } from "./common.styles";
import { ComingSoonTitle, SectionHeaderText } from "./PatientSourcesView.styles";
export const SourceDetailsPageRoot = styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1 0 auto;
    min-height: 100%;
    box-sizing: border-box;
    padding-bottom: 48px;
`;
export const SourceDetailsHeadlineTooltipSlot = styled.div `
    display: contents;

    > span {
        min-width: 0;
        overflow: hidden;
    }
`;
export const SourceDetailsAddressRow = styled.div `
    margin-top: 16px;
    display: flex;
    min-width: 0;

    > span {
        min-width: 0;
        overflow: hidden;
    }
`;
export const SourceDetailsStatusRow = styled(FlexRow) `
    align-items: center;
    gap: 8px;
    margin-top: 12px;
`;
export const SourceDetailsLastRefreshedText = styled.p `
    margin: 0;
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_lighter};
`;
export const SourceDetailsSection = styled.div `
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
`;
export const StatCardsGrid = styled.div `
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    width: 100%;
`;
export const StatCard = styled.button `
    display: flex;
    min-width: 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    box-sizing: border-box;
    padding: 16px;
    border-radius: 24px;
    background-color: ${colors.white_main};
    border: 0.57px solid ${colors.separator_main};
    cursor: pointer;
    text-align: left;
    font: inherit;
    color: inherit;

    @media (hover: hover) {
        &:hover {
            border-color: ${colors.navy_50_opaque};
        }
    }
`;
export const StatCardTopRow = styled(FlexRow) `
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
`;
export const StatCardTextBlock = styled(FlexColumn) `
    gap: 8px;
    width: 100%;
`;
export const StatCardIconCircle = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    box-sizing: border-box;
    border-radius: 16px;
    border: 0.37px solid ${colors.black_10};
    background-color: ${colors.navy_8};
    color: ${colors.black_main};
    flex-shrink: 0;
`;
export const StatDialogIconCircle = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    box-sizing: border-box;
    border-radius: 16px;
    border: 0.37px solid ${colors.black_10};
    background-color: ${colors.provider_icon_bg};
    color: ${colors.black_main};
    flex-shrink: 0;
`;
export const StatCardCountBlock = styled(FlexColumn) `
    align-items: center;
`;
export const StatCardCount = styled.p `
    margin: 0;
    font-size: ${fontSizes.SUPER};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: 46.5px;
    letter-spacing: 0.4px;
    text-align: center;
    color: ${colors.black_main};
`;
export const StatCardCountLabel = SectionHeaderText;
export const StatCardTitle = ComingSoonTitle;
export const StatCardViewAllLink = styled.span `
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.NORMAL};
    line-height: 21.5px;
    letter-spacing: -0.15px;
    color: ${colors.blue_main};
`;
export const PhysiciansCard = styled.button `
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
    border-radius: 20px;
    background-color: ${colors.white_main};
    border: 0.57px solid ${colors.separator_main};
    cursor: pointer;
    text-align: left;
    font: inherit;
    color: inherit;

    @media (hover: hover) {
        &:hover {
            border-color: ${colors.navy_50_opaque};
        }
    }
`;
export const PhysiciansCardTextBlock = styled(FlexColumn) `
    flex: 1;
    min-width: 0;
    gap: 4px;
    justify-content: center;
`;
export const PhysiciansCardCount = styled.p `
    margin: 0;
    flex-shrink: 0;
    font-size: ${fontSizes.LARGE_PLUS};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_main};
`;
export const RecordRow = styled.button `
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
    border: none;
    border-top: 0.57px solid ${colors.separator_main};
    background: transparent;
    cursor: pointer;
    text-align: left;
    font: inherit;
    color: inherit;

    @media (hover: hover) {
        &:hover {
            background-color: ${colors.black_4};
        }
    }
`;
export const StatDialogRecordList = styled.div `
    display: flex;
    flex-direction: column;
    width: calc(100% + 48px);
    margin: 0 -24px;
`;
export const RecordRowDate = styled.span `
    flex-shrink: 0;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: 24px;
    letter-spacing: -0.31px;
    color: ${colors.black_main};
`;
export const RecordRowLabelContainer = styled.div `
    display: flex;
    flex: 1 0 0;
    min-width: 0;

    > span {
        flex: 1;
        min-width: 0;
        overflow: hidden;
    }
`;
export const RecordRowLabel = styled.span `
    ${multilineEllipsis(1)}
    min-width: 0;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: 21px;
    letter-spacing: -0.31px;
    color: ${colors.black_main};
`;
export const RecordRowChevronWrapper = styled.div `
    display: flex;
    align-items: center;
    flex-shrink: 0;
    color: ${colors.history_secondary_text};
`;
export const StatDialogEmptyState = styled(FlexColumn) `
    align-items: center;
    padding: 48px 16px;
    color: ${colors.black_lighter};
    font-size: ${fontSizes.SMALL};
`;
